import {Injectable} from '@angular/core';
import {RestHttpService} from '@catmodules/core/services/rest-http.service';
import {StatusInfo} from '@catmodules/features/types';
import {Restangular} from 'ngx-restangular';

@Injectable()
export class UnitsService extends RestHttpService<StatusInfo> {

  constructor(service: Restangular) {
    super('units', service);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/units/services/units.service.ts